import axios from "axios";
import Vue from "vue";

axios.interceptors.request.use(
  function(config) {
    config.withCredentials = true;
    config.baseURL = process.env.VUE_APP_API_URL;
    config.headers = {
      "Access-Control-Allow-Origin": process.env.VUE_APP_SITE_URL,
      "Access-Control-Allow-Credentials": true,
      "Content-Type": "application/json"
    };
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(function(response) {
  // intercept the global error
  if (response.status === 401) {
    // if the error is 401 and hasent already been retried
    Vue.prototype.$user.set({
      role: "guest"
    });
    // window.location.href = "/";
  }
  return response;
});
export default {
  jsonToQueryString: function(json) {
    return (
      "?" +
      Object.keys(json)
        .map(function(key) {
          return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
        })
        .join("&")
    );
  },
  getSelf: function(vx,cred) {
    let url = "//" + vx.subd + ".vuemix.com/api/v2/users/self";
    if (cred) {
      url += "?"+cred;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(res => {
          // console.log(res.data);
          if (typeof res.data.data != undefined && res.data.data) {
            let u = res.data.data;
            u.short_name = u.email.split("@")[0];
            if (u.first_name) {
              u.short_name = u.first_name;
            }
            u.acc = vx.acc;
            if (u.roles && u.roles.includes("grant_rtmp")) {
              u.can_mirror = true;
            }
            if (u.roles && u.roles.includes("rd_users")) {
              u.adm_users = true;
            }
            if (u.roles && u.roles.includes("mod_self_acc")) {
              u.adm_acc = true;
            }
            u.loc = u.loc || {};
            if (!u.creds && cred) {
              u.creds = {me: cred};
            }
            /* Update vx user state as well */
            window.vx_import_user(window.vx, u);
            return resolve(u);
          } else {
            return reject("User not logged in");
          }
        })
        .catch(e => {
          return reject(e);
        });
    });
  },
  setUserName: function(vx, newUserName) {
    let url = "//" + vx.subd + ".vuemix.com/api/v2/users/self";
    return new Promise((resolve, reject) => {
      axios
        .post(url, {
          nick: newUserName
        })
        .then(res => {
          if (typeof res.data.data != undefined && res.data.data) {
            return resolve(res.data.data);
          } else {
            return reject(new Error("Unknown Error"));
          }
        })
        .catch(e => {
          return reject(e);
        });
    });
  },
  addKeyOBSOLETE: function(key) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v2/content/search.json?tname=NOTHING&${key}`)
        .then(res => {
          if (typeof res.data != undefined && res.data) {
            return resolve(res.data);
          } else {
            return reject(new Error("Unknown error adding key"));
          }
        })
        .catch(e => {
          return reject(e);
        });
      // return resolve(true);
    });
  },
  listKeysOBSOLETE: function() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/v2/users/self`)
        .then(res => {
          if (typeof res.data.data != undefined && res.data.data) {
            return resolve(res.data.data);
          } else {
            return reject(new Error("Unknown error listing key"));
          }
        })
        .catch(e => {
          return reject(e);
        });
      // return resolve(true);
    });
  },
  getTags: function(vx, opt) {
    let url = "//" + vx.subd + ".vuemix.com/api/v2/content/videos/"+opt.id;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(res => {
          return resolve(res.data.data.video.tags);
        })
        .catch(e => {
          return reject(e);
        });
    });
  },
  setTags: function(vx, opt) {
    let url = "//" + vx.subd + ".vuemix.com/api/v2/content/videos/"+opt.id+".json";
    return new Promise((resolve, reject) => {
      let hash = {};
      let data = {};
      opt.tgs.forEach(function(t) {
        hash[t.split("=")[0]] = t;
      });
      opt.set_tgs.forEach(function(t) {
        hash[t.split("=")[0]] = t;
      });
      data.tags = [];
      for (let k in hash) {
        data.tags.push(hash[k]);
      }
      if (opt.title) {
        data.title = opt.title;
      }
      axios
        .put(url, data)
        .then(res => {
          return resolve(res.data);
        })
        .catch(e => {
          return reject(e);
        });
    });
  },
  createStream: function(vx, opt) {
    let url = "//" + vx.subd + ".vuemix.com//api/v2/remotestorage/mm.json";
    if (vx_no_cookies(vx)) {
      url += "?"+vx.user.creds.me;
      url += "&guid="+vx.user.id;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(res => {
          return resolve(res.data);
        })
        .catch(e => {
          return reject(e);
        });
    });
  },
  createShare: function(vx, opt) {
    let url = "//" + vx.subd + ".vuemix.com//api/v2/remotestorage/localdrive.json?";
    if (!opt || !opt.kind) {
      url += "asset_type=share_img";
    } else {
      url += "asset_type="+opt.kind;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(res => {
          return resolve(res.data);
        })
        .catch(e => {
          return reject(e);
        });
    });
  },
  createMyTn: function(vx, opt) {
    let kind = opt.kind || "my_tn";
    let url = "//" + vx.subd + ".vuemix.com//api/v2/remotestorage/localdrive.json?"+
        "asset_type="+kind;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(res => {
          return resolve(res.data);
        })
        .catch(e => {
          return reject(e);
        });
    });
  },
  createObj: function(vx, opt) {
    let kind = "ev_tn";
    let url = "//" + vx.subd + ".vuemix.com//api/v2/remotestorage/localdrive.json?asset_type=evtn&evid="+opt.evid+"&evpart="+opt.evpart;
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(res => {
          return resolve(res.data);
        })
        .catch(e => {
          return reject(e);
        });
    });
  },
  getUID: function(vx, opt) {
    let em = opt.em.replace(/\./g, "%2E");
    let url =
        "//" + vx.subd + ".vuemix.com/api/v2/users/em/" + encodeURIComponent(em);
    if (opt.room) {
      url += "?room="+encodeURIComponent(opt.room);
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(res => {
          if (res.data && res.data) {
            return resolve(res.data);
          }
          return reject({});
        })
        .catch(e => {
          return reject(e);
        });
    });
  },
  getLandingMeet: function(vx, acc) {
    let url = vx.rq_endpoint;
    url += "/adm/account/kp/"+vx.subd+"/meet";
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(res => {
          return resolve(res.data);
        })
        .catch(e => {
          return reject(e);
        });
    });
  },
  getRoomStats: function(vx, acc, room) {
    let url = vx.rq_endpoint+"/room/"+room+"/stats";
    url += "?acc=" + acc;
    if (vx.user && vx.user.creds) {
      url += "&uid=" + vx.user.id;
      if (room == vx.user.my_room_name) {
        url += "&" + vx.user.creds["myroom"];
      } else {
        url += "&" + vx.user.creds["me"];
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then(res => {
            return resolve(res.data);
        })
        .catch(e => {
          return reject(e);
        });
    });
  },
  signOut: function(vx) {
    let url = "//" + vx.subd + ".vuemix.com/users/sign_out.json";
    return new Promise((resolve, reject) => {
      axios
        .delete(url)
        .then(res => {
          return resolve(res);
        })
        .catch(e => {
          return reject(e);
        });
    });
  },
  signIn: function(vx, user, opt) {
    let url_signout = "//" + vx.subd + ".vuemix.com/users/sign_out.json";
    let url_signin = "//" + vx.subd + ".vuemix.com/users/sign_in.json";
    if (opt && opt.nocookie) {
      url_signin += "?onlycred";
    }
    return new Promise((resolve, reject) => {
      axios
        .delete(url_signout)
        .then(res => {
          axios
            .post(url_signin, {
              user: user
            })
            .then(res => {
              // console.log(res.data);
              if (typeof res.data != undefined && res.data) {
                return resolve(res.data);
              } else {
                reject(new Error("User login failed"));
              }
            })
            .catch(e => {
              return reject(e);
            });
        })
        .catch(e => {
          return reject(e);
        });
    });
  }
};
